import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { FindByCompanyIdResult, HistoryLogRepository } from "../domain/HistoryLogRepository";
import { InvoiceHistoryLog } from "../domain/InvoiceHistoryLog";
import { query_dispatcher_get } from "@/api/client";


export class ApiHistoryLogRepository implements HistoryLogRepository {

    query_dispatcher: QueryDispatcher
    constructor() {
        this.query_dispatcher = query_dispatcher_get
    }

    api_to_domain(log: any): InvoiceHistoryLog {
        return new InvoiceHistoryLog({
            id: log.id,
            company_id: log.company_id,
            invoice_type: log.invoice_type,
            state: log.state,
            issuer_nif: log.issuer_nif,
            invoice_series_number: log.invoice_series_number,
            invoice_issue_date: log.invoice_issue_date,
            third_party_name: log.third_party_name,
            third_party_nif: log.third_party_nif,
            total_base_amount: parseFloat(log.total_base_amount).toFixed(2),
            total_tax_amount: parseFloat(log.total_tax_amount).toFixed(2),
            total_amount: parseFloat(log.total_amount).toFixed(2),
            chain_hash: log.chain_hash,
            invoice_registration_date: log.register_generation_dt || '',
            external_invoice_number: log.external_invoice_number || null,
            verifactu_error_msj: log.verifactu_error_msj,
            verifactu_status_code: log.verifactu_status_code,
            auto_send_to_verifactu: log.auto_send_to_verifactu || false,
            error_to_show: log.error_to_show,
            info_verifactu: log.info_verifactu
        });
    }

    async find_by_company_id(company_id: number, limit:number, offset:number, filters?: Record<string, any>): Promise<FindByCompanyIdResult> {
        let args: any = { company_id: company_id, limit: limit, offset: offset }

        // Añadir filtros si existen 
        if (filters) {
            Object.keys(filters).forEach(key => {
                args[key] = filters[key];
            });
        }

        let logs = await this.query_dispatcher.dispatch('get.history.log', args)

        if (!logs || !logs.result || (logs.result && logs.result.length === 0)) {
            return { count: 0, result: [] };
        }

        let a = { count: logs.count, result: logs.result.map(log => this.api_to_domain(log)) };
        return a
    }
}

export class MemoryHistoryLogRepository implements HistoryLogRepository {
    private logs: InvoiceHistoryLog[] = [];

    constructor(logs: InvoiceHistoryLog[] = []) {
        this.logs = logs;
    }

    async find_by_company_id(company_id: number, limit:number, offset:number, filters?: Record<string, any>): Promise<FindByCompanyIdResult> {
        const filteredLogs = this.logs.filter(log => log.company_id === company_id);
        const paginatedLogs = filteredLogs.slice(offset, offset + limit);
        return { count: filteredLogs.length, result: paginatedLogs };
    }
}
